"use client";

const PIPELINE_STEPS = [
  "Collecting data",
  "Getting follower & following lists",
  "Analyzing changes",
  "Packaging your weekly report",
];

interface WeekAnalysisPendingCardProps {
  weekLabel: string;
  username: string;
  availableFromLabel: string;
}

export default function WeekAnalysisPendingCard({
  weekLabel,
  username,
  availableFromLabel,
}: WeekAnalysisPendingCardProps) {
  const handle = `@${username}`;

  return (
    <div className="mt-3 overflow-hidden rounded-2xl border border-line bg-surface shadow-soft">
      <div className="border-b border-line bg-rose-softer/60 px-4 py-3 sm:px-5">
        <p className="text-[12px] font-bold uppercase tracking-wider text-rose-deep">In progress</p>
        <p className="mt-1 text-[13px] text-muted">{weekLabel}</p>
      </div>

      <div className="px-4 py-6 sm:px-5">
        <div className="mx-auto grid h-12 w-12 place-items-center rounded-full grad-bg text-white shadow-soft">
          <svg
            className="h-5 w-5 animate-spin"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
          </svg>
        </div>

        <p className="mt-4 text-center font-display text-[19px] font-extrabold leading-tight text-ink">
          Building your weekly analysis
        </p>
        <p className="mx-auto mt-2 max-w-md text-center text-[13px] leading-relaxed text-muted">
          We&apos;re processing {handle}&apos;s follower and following changes for this week. Your full report lands when the week closes.
        </p>

        <div className="mx-auto mt-5 max-w-sm rounded-xl border border-line bg-rose-softer px-4 py-3">
          <div className="relative h-1.5 overflow-hidden rounded-full bg-rose-soft">
            <div className="absolute inset-y-0 left-0 w-1/3 rounded-full grad-bg animate-[pv-progress_1.4s_ease-in-out_infinite]" />
          </div>
          <p className="mt-2 text-center text-[12px] font-medium text-rose-deep">
            Analysis is running…
          </p>
        </div>

        <ul className="mx-auto mt-5 max-w-sm space-y-2.5">
          {PIPELINE_STEPS.map((step, i) => (
            <li
              key={step}
              className="flex items-center gap-2.5 text-[12.5px] text-muted"
              style={{ animationDelay: `${i * 0.35}s` }}
            >
              <span className="h-1.5 w-1.5 shrink-0 animate-pulse rounded-full bg-rose" />
              {step}
            </li>
          ))}
        </ul>

        <p className="mt-6 text-center text-[13px] font-semibold text-ink">
          Available{" "}
          <span className="text-rose-deep">{availableFromLabel}</span>
        </p>
      </div>
    </div>
  );
}
